import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import contactStyle from "assets/jss/CustomerTradePortal/views/LandingPageSections/contactUsStyle.js";
import PinDrop from "@material-ui/icons/PinDrop";
import Phone from "@material-ui/icons/Phone";


const useStyles = makeStyles(contactStyle);

export default function ContactUsPage() {
    const [specialitySelect, setSpecialitySelect] = React.useState("1");
    const handleSpeciality = (event) => {
        setSpecialitySelect(event.target.value);
    };


    const classes = useStyles();

    let bigman;

    //bigman = <div>
    //    <BingMapsReact
    //        bingMapsKey="SIWegAJs7Ato7dhStGFs~fxC5yP6MFwpRZ0VcnVNHCw~Athsx4Jy9bAGBWMDYy8gTLLk9WDwMFAj6upRG7AYXFOMQzPnFY1ZzOFe2aMbrPCh"
    //        height="500px"
    //        mapOptions={{
    //            navigationBarMode: "square",
    //        }}
    //        width="500px"
    //        viewOptions={{
    //            center: { latitude: 42.360081, longitude: -71.058884 },
    //            mapTypeId: "grayscale",
    //        }}

    //    />
    //</div>


    return (
        <div>
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.contactContent}>
                    <div className={classes.container}>

                        <GridContainer>
                            <GridItem md={6} sm={6}>
                                <h2 className={classes.title}>Send us a message</h2>
                                <p>
                                    You can contact us with anything related to our fencing Products. We
                                    {"'"}ll get in touch with you as soon as possible.
                                    <br />
                                    <br />
                                </p>
                                <form>
                                    <CustomInput
                                        labelText="Your Name"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}

                                        inputProps={{
                                            name: "name",
                                            type: "text",
                                            defaultValue:"Ryan Donnelly"
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Email address"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}

                                        inputProps={{
                                            name: "email",
                                            type: "text",
                                            defaultValue: "rdonnelly@fpmccann.co.uk"
                                        }}
                                    />
                                    <CustomInput
                                        labelText="Phone"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}

                                        inputProps={{
                                            name: "number",
                                            type: "text",
                                            defaultValue: "0753472763"
                                        }}

                                       
                                    />
                                    <CustomInput
                                        labelText="Your message"
                                        id="float"
                                        formControlProps={{
                                            fullWidth: true,
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: "message",
                                            type: "text",
                                            defaultValue: "This is a random message"
                                        }}
                                    />
                                    <div className={classes.textCenter}>
                                        <Button color="info"
                                            style={{
                                            borderRadius: 15,
                                            padding: "12px 16px",
                                            fontSize: "18px"
                                            }}
                                            round>
                                            Contact us
                                        </Button>
                                    </div>
                                </form>
                            </GridItem>
                            <GridItem md={6} sm={6}>

                                <InfoArea
                                    className={classes.info}
                                    title="Find us at the office"
                                    description={
                                        <p>
                                            Brascote Lane, Cadeby<br /> Warwickshire,{" "} <br />
                                            CV13 0BB
                                            <br /> GB
                                        </p>
                                    }
                                    icon={PinDrop}
                                    iconColor="info"
                                />
                                <InfoArea
                                    className={classes.info}
                                    title="Give us a ring"
                                    description={
                                        <p>
                                            Cadeby Depot<br />  01455 292189,  01455 290780 <br />
                                            sales@fpmccann.co.uk
                                            <br />
                                        </p>
                                    }
                                    icon={Phone}
                                    iconColor="info"
                                />

                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}
